// Libs
import { createSlice } from '@reduxjs/toolkit';
import { deleteDocument, editDocument, getDocumentListByFolder, uploadDocument } from './documentThunk';
import { RootState } from '~/utils/redux/store';
// Others

export interface documentState {
  isRefreshDocumentList: boolean;
}

const initialState: documentState = {
  isRefreshDocumentList: false,
};

const documentSlice = createSlice({
  name: 'document',
  initialState,
  reducers: {
    setIsRefreshDocumentList: (state, action) => {
      state.isRefreshDocumentList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // POST: Upload document
    builder
      .addCase(uploadDocument.pending, (state) => {})
      .addCase(uploadDocument.fulfilled, (state) => {})
      .addCase(uploadDocument.rejected, (state) => {});

    // GET: Get document list by folder
    builder
      .addCase(getDocumentListByFolder.pending, (state) => {})
      .addCase(getDocumentListByFolder.fulfilled, (state) => {})
      .addCase(getDocumentListByFolder.rejected, (state) => {});

    // PUT: Edit document
    builder
      .addCase(editDocument.pending, (state) => {})
      .addCase(editDocument.fulfilled, (state) => {})
      .addCase(editDocument.rejected, (state) => {});

    // DELETE: Delete document
    builder
      .addCase(deleteDocument.pending, (state) => {})
      .addCase(deleteDocument.fulfilled, (state) => {})
      .addCase(deleteDocument.rejected, (state) => {});
  },
});

// Action
export const documentActions = documentSlice.actions;

// Selectors
export const selectIsRefreshDocumentList = (state: RootState) => state.document.isRefreshDocumentList;

// Reducer
const documentReducer = documentSlice.reducer;
export default documentReducer;
